import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import enviroment from "./enviroment";
import zdjService from "@/services/zdj/zdjService";
import i18n from "@/i18n";
import VueMeta from 'vue-meta'

Vue.config.productionTip = false
zdjService.logout().then(x => {});
Vue.use(VueMeta);

if (enviroment.domain) window.document.domain = enviroment.domain;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');